export enum MmuUserRoles {
  BASIC = 'basic',
  ENGINEER = 'engineer',
  ADMIN = 'admin'
}

export type UserRole = MmuUserRoles | `${MmuUserRoles}`;
